// react-router 없이 경로 기반 내비게이션을 제공하는 소형 훅 — pushState + popstate 동기화
import { useEffect, useState } from 'react';

/** 내부 내비게이션 발생을 알리는 커스텀 이벤트명 */
const NAV_EVENT = 'hostNavigate';

/** 경로 이동 — 히스토리에 기록하고 구독자(usePathname)에게 알린다 */
export function navigate(path: string, options?: { replace?: boolean }) {
  if (window.location.pathname === path) return;
  if (options?.replace) {
    window.history.replaceState(null, '', path);
  } else {
    window.history.pushState(null, '', path);
  }
  window.dispatchEvent(new Event(NAV_EVENT));
}

/** 현재 pathname을 상태로 구독 — navigate()·브라우저 뒤로/앞으로 모두 반영 */
export function usePathname(): string {
  const [pathname, setPathname] = useState(window.location.pathname);

  useEffect(() => {
    const sync = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', sync);
    window.addEventListener(NAV_EVENT, sync);
    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener(NAV_EVENT, sync);
    };
  }, []);

  return pathname;
}
